import React from 'react';
import PropTypes from 'prop-types';
import {Button} from 'react-bootstrap';
import {WellSurfaceDataShape, PlateType} from '../../constants/dataEnum';
import withIntl from '../../lib/withIntl';
import MotionControlPad from './MotionControlPad';

function PlateViewMotionControl({plateTypeEditorState, handleClickProceed, intl, onResetSafeProbe, errorHandler}) {
  async function handleResetProbePosition(startingPosition, callback) {
    const res = await onResetSafeProbe(startingPosition, callback, errorHandler);
    return res;
  }

  const {wellShape, plateType} = plateTypeEditorState;

  // format:
  // column title (key): plateTypeEditorState properties (value)
  const resultColumnMicroplate = {
    "Plate's Height": 'height',
    "Well's Depth": 'depth',
    'Column Origin': 'columnOrigin',
    'Row Origin': 'rowOrigin',
  };

  const resultColumnIFC = {
    "Plate's Height": 'height',
    'Column Origin': 'columnOrigin',
    'Row Origin': 'rowOrigin',
    "Inlet's Depth": 'depth',
    "Inlet's Diameter": 'length',
  };

  const getTableFormat = (type) => {
    const resultTable = [];
    let resultColumn = resultColumnIFC;

    if (type === PlateType.MICROPLATE) {
      let wellData = {
        "Well's Diameter": 'length',
      };

      if (wellShape !== WellSurfaceDataShape.CIRCLE) {
        wellData = {
          "Well's Width": 'width',
          "Well's Length": 'length',
        };
      }
      resultColumn = {
        ...resultColumnMicroplate,
        ...wellData,
      };
    }

    for (let i = 0; i < Object.keys(resultColumn).length; i += 2) {
      const leftColTitle = Object.keys(resultColumn)[i];
      const leftColValue = `${plateTypeEditorState[resultColumn[leftColTitle]]} (mm)`;

      let rightColTitle = '';
      let rightColValue = '';

      if (Object.keys(resultColumn)[i + 1]) {
        rightColTitle = Object.keys(resultColumn)[i + 1];
        rightColValue = `${plateTypeEditorState[resultColumn[rightColTitle]]} (mm)`;
      }

      resultTable.push(
        <tr className="row-fluid">
          <td className="col-3">{leftColTitle}</td>
          <td className="result-column col-3">
            <span className="result-value">{leftColValue}</span>
          </td>
          <td width="25%" className="col-3">
            {rightColTitle}
          </td>
          <td width="25%" className="result-column col-3">
            <span className="result-value">{rightColValue}</span>
          </td>
        </tr>,
      );
    }

    return resultTable;
  };

  return (
    <div className="plate-view-motion-control">
      <div className="motion-control-pad">
        <div className="section-title bordered">Motion Control Pad</div>
        <div className="motion-control-button-container">
          <MotionControlPad />
          <div className="button-wrapper">
            <Button className="proceed-button" onClick={() => handleClickProceed(null)}>
              {intl.formatMessage({id: 'plateTypeEditorContainer.motionControl.proceedButton'})}
            </Button>
            <Button className="reset-button" bsStyle="success" onClick={() => handleResetProbePosition(null)}>
              {intl.formatMessage({id: 'plateTypeEditorContainer.motionControl.resetButton'})}
            </Button>
          </div>
        </div>
      </div>
      <div className="motion-control-pad">
        <div className="section-title bordered">Result</div>
        <table className="table-result">
          <tbody>{getTableFormat(plateType)}</tbody>
        </table>
      </div>
    </div>
  );
}

export default withIntl(PlateViewMotionControl);

PlateViewMotionControl.propTypes = {
  plateTypeEditorState: PropTypes.any.isRequired,
  handleClickProceed: PropTypes.func.isRequired,
  intl: PropTypes.any.isRequired,
  onResetSafeProbe: PropTypes.func.isRequired,
  errorHandler: PropTypes.func.isRequired,
};
